import React, { useState } from 'react';
import api from '../services/api';

export default function ModalTermos({ onAceito }) {
  const [aba, setAba] = useState('termos');
  const [concordo, setConcordo] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  async function handleAceitar() {
    if (!concordo) return;
    setSalvando(true);
    setErro('');
    try {
      await api.post('/tenant/aceitar-termos');
      onAceito();
    } catch {
      setErro('Erro ao registrar aceite. Tente novamente.');
      setSalvando(false);
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 16,
        width: '100%', maxWidth: 680,
        maxHeight: '90vh',
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 25px 60px rgba(0,0,0,0.4)',
      }}>
        {/* Cabeçalho */}
        <div style={{ padding: '24px 28px 0', borderBottom: '1px solid #e5e7eb' }}>
          <h2 style={{ margin: '0 0 16px', fontSize: 20, fontWeight: 700, color: '#111827' }}>
            Termos de Uso e Política de Privacidade
          </h2>
          <div style={{ display: 'flex', gap: 0, marginBottom: -1 }}>
            {['termos', 'privacidade'].map(a => (
              <button
                key={a}
                onClick={() => setAba(a)}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer',
                  padding: '8px 20px',
                  fontSize: 14, fontWeight: 600,
                  color: aba === a ? '#3b82f6' : '#374151',
                  borderBottom: aba === a ? '2px solid #3b82f6' : '2px solid transparent',
                  transition: 'all .15s',
                }}
              >
                {a === 'termos' ? 'Termos de Uso' : 'Política de Privacidade'}
              </button>
            ))}
          </div>
        </div>

        {/* Conteúdo */}
        <div style={{
          flex: 1, overflowY: 'auto', padding: '24px 28px',
          fontSize: 13.5, lineHeight: 1.7,
          color: '#374151',
        }}>
          {aba === 'termos' ? <TextoTermos /> : <TextoPrivacidade />}
        </div>

        {/* Rodapé */}
        <div style={{
          padding: '16px 28px 24px',
          borderTop: '1px solid #e5e7eb',
        }}>
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', marginBottom: 16 }}>
            <input
              type="checkbox"
              checked={concordo}
              onChange={e => setConcordo(e.target.checked)}
              style={{ marginTop: 2, width: 16, height: 16, flexShrink: 0, accentColor: '#3b82f6', cursor: 'pointer' }}
            />
            <span style={{ fontSize: 13.5, color: '#111827', userSelect: 'none' }}>
              Li e concordo com os{' '}
              <button
                type="button"
                onClick={() => setAba('termos')}
                style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 600 }}
              >
                Termos de Uso
              </button>
              {' '}e a{' '}
              <button
                type="button"
                onClick={() => setAba('privacidade')}
                style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', padding: 0, fontSize: 'inherit', fontWeight: 600 }}
              >
                Política de Privacidade
              </button>
              {' '}da CronoObra.
            </span>
          </label>

          {erro && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca',
              borderRadius: 8, padding: '8px 12px',
              fontSize: 13, color: '#dc2626', marginBottom: 12,
            }}>
              {erro}
            </div>
          )}

          <button
            onClick={handleAceitar}
            disabled={!concordo || salvando}
            style={{
              width: '100%', padding: '13px',
              background: concordo ? '#3b82f6' : '#9ca3af',
              color: '#fff', border: 'none', borderRadius: 10,
              fontSize: 15, fontWeight: 700, cursor: concordo ? 'pointer' : 'not-allowed',
              transition: 'background .15s',
            }}
          >
            {salvando ? 'Registrando...' : 'Aceitar e continuar'}
          </button>
        </div>
      </div>
    </div>
  );
}

function Secao({ titulo, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: '#111827', margin: '0 0 6px' }}>{titulo}</h3>
      {children}
    </div>
  );
}

function TextoTermos() {
  return (
    <>
      <p style={{ marginTop: 0 }}>
        Bem-vindo à <strong>CronoObra</strong>. Ao utilizar nosso sistema, você concorda com os termos e condições descritos abaixo. Leia-os com atenção antes de prosseguir.
      </p>

      <Secao titulo="1. Descrição do Serviço">
        <p>
          A CronoObra é uma plataforma SaaS de gestão de obras, clientes, contratos e finanças voltada a profissionais e empresas da construção civil. O acesso ao sistema é concedido mediante assinatura de um dos planos disponíveis.
        </p>
      </Secao>

      <Secao titulo="2. Cadastro e Responsabilidades">
        <p>
          Ao se cadastrar, você declara que as informações fornecidas são verdadeiras, completas e atualizadas. Você é responsável pela confidencialidade de sua senha e por todas as atividades realizadas em sua conta. Em caso de acesso não autorizado, notifique imediatamente a CronoObra pelo e-mail <strong>contato@cronoobra.com.br</strong>.
        </p>
      </Secao>

      <Secao titulo="3. Planos e Pagamentos">
        <p>
          O acesso ao sistema é condicionado ao pagamento da assinatura do plano escolhido. O vencimento ocorre mensalmente, salvo na modalidade anual (ver Seção 7). Em caso de inadimplência, a conta poderá ser suspensa e, após 60 dias de inadimplência, os dados poderão ser excluídos permanentemente.
        </p>
      </Secao>

      <Secao titulo="4. Uso Permitido">
        <p>
          Você concorda em utilizar o sistema exclusivamente para fins legais e relacionados à gestão de obras e negócios. É vedado usar a plataforma para armazenar dados fraudulentos, realizar engenharia reversa, tentar acesso não autorizado a outros dados ou qualquer atividade que viole a legislação brasileira.
        </p>
      </Secao>

      <Secao titulo="5. Disponibilidade">
        <p>
          A CronoObra empenha-se em manter o sistema disponível 24 horas por dia, 7 dias por semana, mas não garante disponibilidade ininterrupta. Manutenções programadas serão comunicadas com antecedência sempre que possível.
        </p>
      </Secao>

      <Secao titulo="6. Limitação de Responsabilidade">
        <p>
          A CronoObra não se responsabiliza por perdas ou danos decorrentes de uso indevido do sistema, falhas de conexão à internet, ou eventos fora de seu controle. A responsabilidade máxima da CronoObra fica limitada ao valor pago pelo plano no mês vigente.
        </p>
      </Secao>

      <Secao titulo="7. Cancelamento">
        <p>
          Você pode cancelar sua assinatura a qualquer momento pela tela de Plano. Após o cancelamento, o acesso permanece ativo até o fim do período pago. Não há reembolso proporcional por cancelamento antecipado.
        </p>
        <p>
          <strong>Plano anual:</strong> a contratação anual tem desconto de 10% condicionado à permanência pelos 12 meses contratados. Cancelar antes desse prazo gera multa de 10% sobre o valor das parcelas mensais restantes até o fim do período. Essa condição é exibida de forma destacada antes da confirmação da contratação anual.
        </p>
      </Secao>

      <Secao titulo="8. Alterações nos Termos">
        <p>
          A CronoObra pode atualizar estes termos a qualquer momento. Mudanças relevantes serão comunicadas por e-mail ou aviso no sistema. O uso continuado após a notificação implica aceitação dos novos termos.
        </p>
      </Secao>

      <Secao titulo="9. Lei Aplicável">
        <p>
          Estes Termos são regidos pelas leis brasileiras. Fica eleito o foro da comarca de domicílio do usuário para dirimir quaisquer controvérsias.
        </p>
      </Secao>

      <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 0 }}>
        Última atualização: setembro de 2026.
      </p>
    </>
  );
}

function TextoPrivacidade() {
  return (
    <>
      <p style={{ marginTop: 0 }}>
        Esta Política de Privacidade explica como a <strong>CronoObra</strong> coleta, utiliza, armazena e protege seus dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018).
      </p>

      <Secao titulo="1. Dados Coletados">
        <p>Coletamos os seguintes dados para prestação do serviço:</p>
        <ul style={{ paddingLeft: 20, marginTop: 4 }}>
          <li><strong>Dados de cadastro:</strong> nome, e-mail, telefone, nome da empresa e CPF/CNPJ.</li>
          <li><strong>Dados de uso:</strong> obras, clientes, serviços, pagamentos e documentos que você insere no sistema.</li>
          <li><strong>Dados de acesso:</strong> endereço IP, data e hora de login, dispositivo utilizado.</li>
          <li><strong>Dados de pagamento:</strong> processados pelo Mercado Pago. A CronoObra não armazena dados completos de cartão de crédito.</li>
        </ul>
      </Secao>

      <Secao titulo="2. Finalidade do Tratamento">
        <p>Seus dados são utilizados para:</p>
        <ul style={{ paddingLeft: 20, marginTop: 4 }}>
          <li>Prestação e melhoria do serviço CronoObra;</li>
          <li>Processamento de pagamentos e gestão de assinaturas;</li>
          <li>Envio de notificações operacionais e e-mails transacionais;</li>
          <li>Cumprimento de obrigações legais;</li>
          <li>Segurança e prevenção de fraudes.</li>
        </ul>
      </Secao>

      <Secao titulo="3. Compartilhamento de Dados">
        <p>
          Seus dados não são vendidos a terceiros. Podemos compartilhá-los apenas com fornecedores essenciais à operação do serviço (hospedagem em nuvem, processador de pagamentos Mercado Pago, serviço de e-mail), sempre sob cláusulas de confidencialidade.
        </p>
      </Secao>

      <Secao titulo="4. Armazenamento e Segurança">
        <p>
          Os dados são armazenados em servidores seguros com criptografia em trânsito (HTTPS/TLS). Adotamos boas práticas de segurança para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição.
        </p>
      </Secao>

      <Secao titulo="5. Retenção de Dados">
        <p>
          Seus dados são mantidos enquanto a conta estiver ativa. Após o cancelamento ou exclusão da conta, os dados são mantidos por até 90 dias para fins de backup e obrigações legais, sendo então excluídos permanentemente. Contas inadimplentes por mais de 60 dias terão os dados excluídos.
        </p>
      </Secao>

      <Secao titulo="6. Seus Direitos (LGPD)">
        <p>Como titular dos dados, você tem direito a:</p>
        <ul style={{ paddingLeft: 20, marginTop: 4 }}>
          <li>Confirmar a existência de tratamento e acessar seus dados;</li>
          <li>Solicitar correção de dados incompletos ou incorretos;</li>
          <li>Solicitar a exclusão de dados desnecessários;</li>
          <li>Revogar o consentimento a qualquer momento;</li>
          <li>Solicitar a portabilidade dos seus dados.</li>
        </ul>
        <p>Para exercer esses direitos, entre em contato: <strong>contato@cronoobra.com.br</strong>.</p>
      </Secao>

      <Secao titulo="7. Cookies">
        <p>
          O sistema utiliza cookies estritamente necessários para manter sua sessão autenticada. Nossos landing pages utilizam cookies analíticos do Google Analytics para medir o tráfego. Você pode recusá-los no banner de cookies exibido na primeira visita.
        </p>
      </Secao>

      <Secao titulo="8. Contato do Encarregado (DPO)">
        <p>
          Dúvidas sobre esta política podem ser enviadas para <strong>contato@cronoobra.com.br</strong>.
        </p>
      </Secao>

      <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 0 }}>
        Última atualização: maio de 2026.
      </p>
    </>
  );
}
